import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWagtailComponent } from './simple-icons-wagtail.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWagtailComponent ],
    exports:      [ SimpleIconsWagtailComponent ],
    bootstrap:    []
})
export class SimpleIconsWagtailModule {}
